<div class="ff-page-wrapper">

  <div class="ff-wrapper">
    <p-progressBar mode="indeterminate" *ngIf="!loadedForm"></p-progressBar>

    <ng-container *ngIf="loadedForm">

      <div class="config-card">

        <!-- Cabecera de la tarjeta: título + contador -->
        <div class="cc-page-header cc-page-header--form">
          <div class="cc-page-header-title">
            <i class="pi pi-images"></i>
            <span>{{ (id ? 'FASCICLE.EDIT_FASCICLE' : 'FASCICLE.NEW_FASCICLE') | translate }}</span>
          </div>
          <div class="cc-page-header-meta">
            <span class="config-header-count">
              <p-progressSpinner *ngIf="searchingProducts" strokeWidth="7" [style]="{ width: '14px', height: '14px' }"></p-progressSpinner>
              <ng-container *ngIf="!searchingProducts">
                <span>{{ 'FASCICLE.TOTAL_PRODUCT_FOUND' | translate }}</span>
                <strong [class.text-red-400]="totalProducts === '0'">{{ totalProducts }}</strong>
              </ng-container>
            </span>
          </div>
        </div>

        <div class="config-body">

          <!-- SECCIÓN: Información básica -->
          <section class="form-section">
            <h4 class="section-title">{{ 'FASCICLE.SECTION_BASIC' | translate }}</h4>
            <form [formGroup]="form">
              <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            </form>
          </section>

          <!-- SECCIÓN: Plantillas -->
          <section class="form-section">
            <h4 class="section-title">{{ 'FASCICLE.TEMPLATES' | translate }}</h4>
            <p-listbox
              [options]="templateOptions"
              [(ngModel)]="model.defaultTemplate"
              optionLabel="label"
              optionValue="value"
              [style]="{ width: '100%' }"
              styleClass="ff-template-listbox"
            ></p-listbox>
          </section>

          <!-- SECCIÓN: Filtros -->
          <section class="form-section">
            <h4 class="section-title">{{ 'FASCICLE.SECTION_FILTERS' | translate }}</h4>

            <div class="field">
              <label>{{ 'FASCICLE.CATEGORIES' | translate }}</label>
              <div class="ff-category-tree">
                <p-tree
                  [value]="categoryTreeNodes"
                  selectionMode="checkbox"
                  [(selection)]="selectedCategoryNodes"
                  (onNodeSelect)="onCategoriesChange()"
                  (onNodeUnselect)="onCategoriesChange()"
                  [style]="{ width: '100%' }"
                ></p-tree>
              </div>
            </div>

            <div class="field">
              <label>{{ 'FASCICLE.TAGS' | translate }}</label>
              <p-multiSelect
                [options]="tagOptions"
                [(ngModel)]="model.tags"
                optionLabel="label"
                optionValue="value"
                display="chip"
                appendTo="body"
                [style]="{ width: '100%' }"
                (onChange)="onTagsChange()"
              ></p-multiSelect>
            </div>
          </section>

        </div>
      </div>

      <!-- Acciones -->
      <div class="actions-row">
        <p-button
          [disabled]="!form.valid || spinnerSave"
          [label]="'FORM.SAVE' | translate"
          severity="primary"
          size="small"
          (onClick)="save()"
        ></p-button>
        <p-button
          severity="secondary"
          [outlined]="true"
          size="small"
          [label]="'FORM.CANCEL' | translate"
          (onClick)="cancel()"
        ></p-button>
        <p-progressSpinner
          *ngIf="spinnerSave"
          strokeWidth="7"
          [style]="{ width: '32px', height: '32px' }"
        ></p-progressSpinner>
      </div>

    </ng-container>
  </div>

</div>
